<template>
  <div id="app">
    <div v-if="authenticated">

      <!-- Special place for inserting fullscreen components (e.g. ErrorPage) -->
      <router-view name="fullscreen"></router-view>

      <!-- Conditionally show ErrorPage component directly -->
      <error-page v-if="showErrorPage"></error-page>

      <error-bubble></error-bubble>

      <navbar v-bind:showBurger="hideSidebar" v-on:toggleSidebar="hideSidebar = !hideSidebar"></navbar>
      <sidebar v-bind:class="{ 'is-hidden-touch': hideSidebar }"></sidebar>
      <app-main></app-main>
    </div>
    <div v-else>
      <login></login>
    </div>
  </div>
</template>

<script>
  import Navbar from './components/layout/Navbar'
  import Sidebar from './components/layout/Sidebar'
  import AppMain from './components/layout/AppMain'
  import ErrorBubble from './components/layout/ErrorBubble'
  import ErrorPage from './components/ErrorPage'
  import Login from './components/Login'

  export default {
    data () {
      return {
        // Hide sidebar (only on mobile devices)
        hideSidebar: true,
        showErrorPage: false
      }
    },

    computed: {
      authenticated () {
        return this.$store.state.authenticated
      }
    },

    components: {
      Navbar,
      Sidebar,
      AppMain,
      ErrorBubble,
      ErrorPage,
      Login
    },

    watch: {
      // Hide sidebar on route change
      '$route.query' () {
        this.hideSidebar = true
      },

      // Handle request errors
      '$store.state.isError' (isError) {
        if (isError) {
          if (this.$store.state.error.message === 'Network Error') {
            this.$store.commit('SHOW_ERROR_BUBBLE', true)
          } else if (this.$store.state.error.response.status === 404) {
            this.showErrorPage = true
          } else if (this.$store.state.error.response.status === 401 || this.$store.state.error.response.status === 403) {
            this.$store.commit('LOGOUT')
            this.$store.commit('SET_AUTHENTICATED', false)

            window.localStorage.clear()
          }
        }
        this.$store.commit('CLEAR_ERROR')
      }
    }
  }
</script>

<style lang="scss">
  @import '~animate.css';
  .animated {
    animation-duration: .377s;
  }

  $turquoise: #0097A7;
  $blue: #0288D1;
  $green: #43A047;
  $yellow: #FDD835;
  $modal-z: 2000;
  $modal-content-width: 460px;
  @import '~bulma';
  @import '~bulma-tooltip/tooltip';

  @import '~wysiwyg.css/wysiwyg.sass';
  @import '~nprogress/nprogress.css';

  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome';
</style>



// WEBPACK FOOTER //
// App.vue?1b456822